<template>
    <div class="animated fadeIn">
        <basic-heading :title="'Result Exports'"></basic-heading>
        <result-export-table 
            :collection="export_collection" 
            :isListPage="true" 
            @rowClick="handleRowClick"
        ></result-export-table>
    </div>
</template>
<script>
import BasicHeading from '@/components/shared/BasicHeading.vue'
import ResultExportTable from '@/components/lab/resultexport/ResultExportTable.vue'
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const ResultExportRepository = LabRepositoryFactory.get("resultExport");

export default {
    name: "ResultExportIndex",
    components: {
        BasicHeading,
        ResultExportTable
    },
    data() {
        return {
            export_collection: null
        }
    },
    methods: {
        async fetchCollection() {
            await ResultExportRepository.getAll().then((response) => {
                this.export_collection = response.data.data;
            });
        },
        handleRowClick(row) {
            this.$router.push('/result-exports/'+row.id)
        }
    },
    async mounted() {
        await this.fetchCollection()
    }
}
</script>